export default __webpack_public_path__ + "static/media/klaw-pinout-v2.2@3x.64e4867d.png";